import React, { Component } from "react";
import axios from "axios";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import $ from "jquery";

import { singleSignOn } from "../../../config/client_api_calls";
import {
  COMPANY_NAME,
  LOGO,
  THEME_COLOR,
  APP_URL,
  APP_LIVE_URL,
} from "../../../config/config";
import helpherClass from "../../../config/helperClass";
import {
  clearClientSession,
  encrypt,
  setSessionTimerCookies,
  getParentDomain,
  COOKIE_OPTS,
} from "../../../config/cookieUtils";
const auth = new helpherClass();

export default class SsoAuthentication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      successMessage: "",
    };
  }

  async componentDidMount() {
    let reseller_url = this.props.match.params.reseller_url;
    let token_code = this.props.match.params.token_code;
    let client_id = this.props.match.params.client_id;
    // console.log(
    //   "reseller_url: " +
    //   reseller_url +
    //   " \nclient_id: " +
    //   client_id +
    //   " \n\ntoken_code: " +
    //   token_code
    // );
    if (reseller_url === "" && token_code === "") {
      this.setState({
        errorMessage: "URL is not valid. Please enter the valid URL.",
      });
    } else {
      let apiHit = await singleSignOn(token_code, reseller_url, client_id);
      // console.log("apiHit.data: ", apiHit.data);
      if (
        apiHit.data.status === 404 &&
        apiHit.data.message === "Invalid or Expired Token."
      ) {
        //window.location.replace("/error");
        this.setState({
          errorMessage: "Invalid credentials or expired token.",
          successMessage: "",
        });
      } else if (
        apiHit.data.status === 200 &&
        apiHit.data.message === "success"
      ) {
        //Remove Previous Session — reliable cleanup on all paths/domains
        console.info("[SSO] Clearing previous client session cookies");
        clearClientSession();

        // Set identity cookies with explicit path
        Cookies.set("client_name__", encrypt(apiHit.data.name), COOKIE_OPTS);
        Cookies.set("client_tkn__", encrypt(apiHit.data.token), COOKIE_OPTS);
        Cookies.set("client_acn__", encrypt(apiHit.data.accountno), COOKIE_OPTS);
        Cookies.set("client_eml__", encrypt(apiHit.data.email), COOKIE_OPTS);
        Cookies.set("client_comp_nme__", encrypt(apiHit.data.comp_name), COOKIE_OPTS);
        Cookies.set("client_title__", encrypt(apiHit.data.title), COOKIE_OPTS);
        Cookies.set("client_phone__", encrypt(apiHit.data.phone), COOKIE_OPTS);
        Cookies.set("client_adress__", encrypt(apiHit.data.address), COOKIE_OPTS);
        Cookies.set("client_country__", encrypt(apiHit.data.country), COOKIE_OPTS);
        Cookies.set("client_user_type__", encrypt(apiHit.data.user_type), COOKIE_OPTS);
        Cookies.set("client_parent_accountno__", encrypt(apiHit.data.parent_accountno), COOKIE_OPTS);
        Cookies.set("residentifier__", encrypt(apiHit.data.reseller_domain_identifier), COOKIE_OPTS);
        Cookies.set("reslogo__", encrypt(apiHit.data.reseller_logo), COOKIE_OPTS);
        Cookies.set("restkn__", encrypt(apiHit.data.reseller_hash), COOKIE_OPTS);
        Cookies.set("resacct__", encrypt(apiHit.data.reseller_accountno), COOKIE_OPTS);
        Cookies.set("filer_id__", encrypt(apiHit.data.filer_id), COOKIE_OPTS);
        Cookies.set("client_domain_name__", encrypt(apiHit.data.domain_name), COOKIE_OPTS);

        // Set session timer cookies (4h default, or use backend-provided expiry)
        const tokenExpiryMs = apiHit.data.token_expiry || null;
        setSessionTimerCookies(tokenExpiryMs);
        console.info("[SSO] Session timer cookies set, expiry:", tokenExpiryMs || "default 4h");

        // Track SSO handshake for logout flow
        localStorage.setItem("client_sso_handshake", "Yes");

        // Set a lightweight session indicator on the parent domain so the
        // sharelink frontend (on a sibling subdomain) can detect the active session.
        try {
          const _parentDomain = getParentDomain();
          if (_parentDomain) {
            Cookies.set('client_sl_session__', '1', { path: '/', domain: _parentDomain, expires: 1 });
          }
        } catch (_e) {}

        this.setState({
          errorMessage: "",
          successMessage: "Account authenticated successfully.",
        });

        const {
          voicePermissionAdmin,
          integrationInfo,
          parentIntegration,
          form_external_link,
          unsignedAgreements,
          user_type,
        } = apiHit.data;

        const hasChildInt =
          Array.isArray(integrationInfo) && integrationInfo.length > 0;
        const hasParentInt =
          Array.isArray(parentIntegration) && parentIntegration.length > 0;

        const baseChecks =
          voicePermissionAdmin === "Yes" &&
          unsignedAgreements === "No" &&
          typeof form_external_link === "string" &&
          form_external_link.trim() !== "" &&
          hasChildInt;

        let isDirectSSO = false;
        if (baseChecks) {
          if (user_type === "Super") {
            isDirectSSO =
              integrationInfo[0].enable === "Yes" &&
              integrationInfo[0].direct_sso === "Yes";
          } else if (user_type === "Sub") {
            isDirectSSO =
              integrationInfo[0].enable === "Yes" &&
              integrationInfo[0].direct_sso === "Yes" &&
              hasParentInt &&
              parentIntegration[0].enable === "Yes" &&
              parentIntegration[0].direct_sso === "Yes";
          }
        }


        if (isDirectSSO) {
          const accountno = apiHit.data.accountno;
          const email = apiHit.data.email;
          const firstName = apiHit.data.name;
          const compName = apiHit.data.comp_name;
          const userType = apiHit.data.user_type;
          const address = apiHit.data.address || "";
          const title = apiHit.data.title || "";
          const phone = apiHit.data.phone || "";
          const country = apiHit.data.country || "";
          const city = apiHit.data.city || "";
          const zip = apiHit.data.zip || "";
          const stateStr = apiHit.data.state || "";
          const account_status =
            apiHit.data.status === 200 ? "active" : "inactive";
          const status = account_status === "active" ? 1 : 0;
          const parent_accountno = apiHit.data.parent_accountno || null;
          const serviceData = this.state.serviceArray_voicealerts || [];
          const return_url =
            APP_LIVE_URL + auth.getResellerRegToken() + "/client";

          // Extract OCN from integrationInfo
          const ocn =
            integrationInfo && integrationInfo.length > 0 && integrationInfo[0].ocn
              ? integrationInfo[0].ocn
              : "";

          const tokenData = {
            accountno,
            email,
            firstName,
            compName,
            userType,
            status,
            title,
            phone,
            address,
            city,
            state: stateStr,
            zip,
            country,
            password: "",
            ocn,
            serviceData,
            return_url,
            isDirectSSO,
            ...(userType === "Sub" ? { parent_accountno } : {}),
          };

          const tokenDataString = JSON.stringify(tokenData);
          const secretKey =
            process.env.REACT_APP_CARRIER_VOICE_ALERTS_SECRET_KEY;
          const encryptedToken = this.pythonEncrypt(tokenDataString, secretKey);

          const finalUrl = form_external_link
            .replace(/\{{va_parameters\}}/g, encryptedToken)
            .replace(/\{{va_parameters_brand\}}/g, "");

          window.location.replace(finalUrl);
          return;
        }

        setTimeout(function () {
          window.location.replace("/" + reseller_url + "/client/dashboard");
        }, 3000);
      } else {
        this.setState({
          errorMessage:
            "Your account cannot be authenticated this time. Please check the URL or try again later.",
          successMessage: "",
        });
      }
    }
  }

  pythonEncrypt = (data, passphrase) => {
    const secretKey = CryptoJS.enc.Hex.parse(passphrase);
    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(data, secretKey, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Concatenate raw IV + ciphertext (in binary form)
    const rawIv = iv;
    const rawCiphertext = CryptoJS.enc.Base64.parse(encrypted.toString());

    const combined = rawIv.concat(rawCiphertext);

    const base64Encoded = CryptoJS.enc.Base64.stringify(combined);

    return base64Encoded
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  };

  render() {
    return (
      <div className="nk-content ">
        <div className="container-fluid">
          <div className="nk-content-inner">
            <div className="nk-content-body">
              {this.state.errorMessage !== "" ? (
                <div className="example-alert">
                  <div className="alert alert-pro alert-danger">
                    <div className="alert-text">
                      <h4>Error</h4>
                      <p>{this.state.errorMessage}</p>
                    </div>
                  </div>
                </div>
              ) : null}

              {this.state.successMessage !== "" ? (
                <div className="example-alert">
                  <div className="alert alert-pro alert-success">
                    <div className="alert-text">
                      <h4>Success</h4>
                      <p>{this.state.successMessage}</p>
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="text-center" style={{ marginTop: "20%" }}>
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
